import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContentWithCards } from "../components/DialogContent";
import { TextLabel } from "../components/TextLabel";
import { Progress } from "../components/Progress";

export const OrganizationInfoDialog = ({
  onClose,
  onEdit,
  name,
  amauntOfDevices,
  loading
}) => (
  <Dialog maxWidth="lg" scroll="body" onClose={onClose} open spacing={0}>
    <DialogTitle onEdit={onEdit} darkBg>
      Organization: {name}
    </DialogTitle>
    <DialogContentWithCards>
      {loading && <Progress />}
      <TextLabel label="Name" value={name} />
      <TextLabel label="Number Of Devices" value={amauntOfDevices} />
      <br />
    </DialogContentWithCards>
  </Dialog>
);
